(function ($) {
    $(document).ready(function () {

        $(document).on('click', '.feather-search', function () {
            $('#searchform').toggle( "slide" );
        });

    });
})(jQuery);